export interface ThemeGroup {
  id: number;
  code: string;
  name: string;
  /** 상품 하나가 이 그룹에서 고를 수 있는 테마 수 상한. null 이면 무제한. 서버도 같은 값으로 검증한다. */
  maxSelectable: number | null;
  sortOrder: number;
}

export interface Theme {
  id: number;
  code: string;
  name: string;
  emoji?: string | null;
  /** 호스트 입력폼 판정 문구. 어드민 태깅 모달에서는 칩 호버 툴팁으로 쓴다. */
  guide?: string | null;
  sortOrder: number;
  groupId: number;
  group?: ThemeGroup;
}

/** 칩 UI 가 그리는 단위 — 서버가 준 평면 목록을 그룹 경계로 나눈 것. */
export interface ThemeGroupSection {
  group: ThemeGroup;
  themes: Theme[];
}

/**
 * 평면 테마 목록을 그룹 섹션으로 묶는다.
 *
 * 서버(`GET /api/themes`)가 이미 그룹 순서 → 그룹 내 순서로 정렬해 내려주므로 **정렬하지 않고
 * 경계만 나눈다.** 여기서 다시 정렬하면 서버가 정한 노출 순서와 어긋날 수 있다.
 */
export function groupThemes(themes: Theme[]): ThemeGroupSection[] {
  const sections: ThemeGroupSection[] = [];
  for (const theme of themes) {
    // 그룹이 없으면 어느 섹션에도 그릴 수 없다. 서버가 group 을 항상 채우지만, 빠진 응답이 와도
    // 화면 전체가 깨지지 않게 건너뛴다.
    if (!theme.group) continue;
    const last = sections[sections.length - 1];
    if (last && last.group.id === theme.group.id) {
      last.themes.push(theme);
      continue;
    }
    sections.push({ group: theme.group, themes: [theme] });
  }
  return sections;
}
